<template>
    <div class="mpc-statistics-page">
        <v-container>
            <v-tabs v-model="activeTab" class="selection-tabs" centered height="30">
                <v-tab :to="{ name: 'mpcStatisticsDaily', query: { token: router.currentRoute.value.query.token } }" value="daily">
                    Daglig
                </v-tab>
                <v-tab :to="{ name: 'mpcStatisticsMonthly', query: { token: router.currentRoute.value.query.token } }" value="monthly">
                    Månedlig
                </v-tab>
                <v-tab :to="{ name: 'mpcStatisticsExport', query: { token: router.currentRoute.value.query.token } }" value="export">
                    Eksport
                </v-tab>
            </v-tabs>
            <v-divider />
        </v-container>
        <router-view />
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useEmitter, Events } from '@/plugins/emitter';

const route = useRoute();
const router = useRouter();
const eventbus = useEmitter();

const activeTab = ref<string>(tabFromRoute(String(route.name)));

watch(
    () => route.name,
    name => {
        activeTab.value = tabFromRoute(String(name));
    }
);

eventbus.emitter.emit(Events.menuUpdate, 'stats');

function tabFromRoute(name: string): string {
    if (name === 'mpcStatisticsMonthly') return 'monthly';
    if (name === 'mpcStatisticsExport') return 'export';
    return 'daily';
}
</script>
